import { Tooltip, TreeSelect } from "antd";

interface SelectTreeProps {
  value?: number;
  onChange?: (value: number | null) => void;
  list: any[];
  loading: boolean;
  style?: React.CSSProperties;
  props?: any;
}

const SelectTreeCadastro = ({ value, onChange, list, loading, style, props }: SelectTreeProps) => {
  const generateTree = (value: any[] = []) => {
    var retorno: any[] = [];
    value.map(({ filhos, ...props }: any) => {
      if (filhos?.length === 0) {
        filhos = undefined;
      }
      retorno.push({
        value: props.id,
        title: props.denominacao,
        children: generateTree(filhos),
        key: props.id,
      });
    });

    return retorno;
  };

  return (
    <TreeSelect
      showSearch
      value={value}
      maxTagCount="responsive"
      maxTagPlaceholder={(omittedValues) => (
        <Tooltip
          styles={{ root: { pointerEvents: "none" } }}
          title={
            <ul style={{ paddingLeft: 16, margin: 0 }}>
              {omittedValues.map((field, index) => (
                <li key={index}>{field.label}</li>
              ))}
            </ul>
          }
        >
          <span>{`+ ${omittedValues.length} ...`}</span>
        </Tooltip>
      )}
      treeNodeFilterProp="title"
      treeLine
      allowClear
      onChange={(selectedValue) => {
        onChange?.(selectedValue);
      }}
      loading={loading}
      style={style}
      treeData={generateTree(list)}
      {...props}
    />
  );
};

export default SelectTreeCadastro;
